import { createFileRoute, redirect } from "@tanstack/react-router"
import * as z from "zod"

import { generateMetaTags } from "@repo/seo/generate-meta-tags"
import { pick } from "@repo/utils/collections"
import { sharedConfig } from "~/lib/config/shared"
import { isAbsoluteUrl } from "~/lib/utils/http"
import { AuthLayout } from "~/modules/auth/components/auth-layout"
import { UpdatePasswordForm } from "./update-password-form"

const searchSchema = z.object({
  next: z
    .string()
    .optional()
    .refine(
      // We do not want to redirect to absolute URLs (like //evil.com/foo)
      (v) => v === undefined || v === "" || !isAbsoluteUrl(v),
      "Invalid next",
    )
    .catch(""),
})

export const Route = createFileRoute("/_auth-layout/auth/update-password")({
  component: UpdatePasswordScreen,
  validateSearch: searchSchema,
  beforeLoad: async ({ context, location }) => {
    if (!context.user) {
      throw redirect({
        to: "/auth/sign-in",
        search: {
          next: location.href,
        },
      })
    }
  },
  loaderDeps: ({ search }) => pick(search, ["next"]),
  head: ({ match }) => ({
    meta: generateMetaTags({
      base: {
        title: `Update Password | ${sharedConfig.appName}`,
        description: `Update your ${sharedConfig.appName} password`,
        url: sharedConfig.baseUrl + match.fullPath,
      },
      robots: ["noindex", "nofollow", "noarchive"],
    }),
  }),
})

function UpdatePasswordScreen() {
  const { next } = Route.useSearch()

  return (
    <AuthLayout title="Update password">
      <UpdatePasswordForm next={next} />
    </AuthLayout>
  )
}
